import tools from "../../tools";
//导入draggable组件
import draggable from 'vuedraggable'


export default {
    name: 'paperExerciseCreate',
    //注册draggable组件
    components: {
        draggable,
    },
    watch: {
        //如果路由发生了变化，更新页面数据
        $route(to, from) {
            if (to.path !== from.path) {
                if (this.exercisePoolId != this.$route.params.exercisePoolId) {
                    this.exercisePoolId = this.$route.params.exercisePoolId;
                }
                if (this.paperId != this.$route.params.paperId) {
                    this.paperId = this.$route.params.paperId;
                }
                this.init();
            }
        }
    },
    data() {
        return {
            //试卷库id
            exercisePoolId: this.$route.params.exercisePoolId,
            //试卷库名称
            exercisePoolName: "",
            SubjectCourseId: "",
            SubjectCourseName: "",
            //试卷列表
            paperList: [],

            //试卷信息
            paperId: this.$route.params.paperId,
            paperName: "",
            paperExCount: 0,
            paperScore: 0,
            paperExerciseList: [],
            paperExerciseListByExerciseTypeAlias: [],

            //创建/编辑习题
            paperExerciseCreateIframeIsShow: true,
            paperExerciseCreateIframeSrc: "",
            paperExerciseCreateIframeLoad: false,
            paperExerciseId: this.$route.params.exerciseId ? this.$route.params.exerciseId : 0,
            paperExerciseScore: 0,
            paperExercise: "", //当前习题模型
            isCreateEx: false, //是否新建习题

            //创建&编辑习题提示消息
            isShowEditExerciseIframeConfim: false,
            editExerciseIframeCallback: "", //回调方法

            drag: false, //拖拽操作
        }
    },
    // 组件实例创建后
    created() {
        this.$emit("header", false);
        this.$emit("footer", false);
    },
    // 组件挂载完成
    mounted() {
        this.init();

        window.removeEventListener('message', this.exerciseIframeEventListener, false);
        window.addEventListener('message', this.exerciseIframeEventListener, false);
    },
    updated() {

    },
    methods: {
        //返回
        returnClose() {
            let that = this;
            that.exerciseIframePostMessage(function () {
                try {
                    window.removeEventListener('message', this.exerciseIframeEventListener, false);
                } catch (e) {
                    console.log(e)
                }
                this.$router.push("/questionManagement/paperedit/" + this.exercisePoolId + "/" + this.paperId);
            })
        },
        init() {
            this.getExercisePoolById();
            this.getHtePoolHte();
        },
        //获取试卷库信息
        getExercisePoolById() {
            let that = this;
            this.$tools.api(
                'ExercisePools.GetExercisePoolByHTEIdAsync',
                {HTEPaperid: that.exercisePoolId},
                function (res) {
                    that.exercisePoolName = res.ExercisePoolName;
                    that.SubjectCourseId = res.SubjectCourseId;
                    that.SubjectCourseName = res.SubjectCourseName;
                }
            )
        },
        //获取试卷库下所有试卷
        getHtePoolHte() {
            let that = this;
            this.$tools.api(
                'ExercisePools.GetHtePoolHteAsync',
                {
                    exercisePoolId: that.exercisePoolId,
                },
                function (res) {
                    if (res && res.length > 0) {
                        that.paperList = res;
                        if (that.paperList.length > 0) {
                            that.getHTEPaper();
                        }
                    }
                }
            )
        },
        //获取试卷
        getHTEPaper() {
            let that = this;
            let onePaperData = that.paperList.find(item => {
                return item.HteId == that.paperId;
            })
            that.paperName = onePaperData.HteName;
            that.paperExCount = onePaperData.IncludeExerciseCount;
            that.paperScore = onePaperData.Score;
            that.getHTEPaperExercise();
        },
        //获取试卷里的习题
        getHTEPaperExercise() {
            let that = this;
            that.paperExerciseList = [];
            that.paperExerciseListByExerciseTypeAlias = [];
            this.$tools.api(
                'ExercisePools.GetHTEPaperToExerciseIDAsync',
                {
                    HTEPaperid: that.paperId,
                },
                function (res) {
                    if (res && res.length > 0) {
                        that.paperExerciseList = res;
                        if (that.paperExerciseId == undefined) {
                            that.paperExercise = res[0];
                            that.paperExerciseId = that.paperExercise.ExerciseId;
                        } else {
                            that.paperExercise = res.find(function (item) {
                                return item.ExerciseId == that.paperExerciseId
                            });

                            //滚动到编辑的小题
                            that.$nextTick(function () {
                                let scrollTopSetInterval = setInterval(function () {
                                    if ($(".oneexercise[hex-exerciseId=" + that.paperExerciseId + "]").length > 0 && $(".excontent .exlist").length > 0) {
                                        $(".excontent .exlist").animate({scrollTop: $(".oneexercise[hex-exerciseId=" + that.paperExerciseId + "]").offset().top - $(".excontent .exlist").offset().top + $(".excontent .exlist").scrollTop()}, 800);
                                        clearInterval(scrollTopSetInterval);
                                    }
                                }, 500)
                            })
                        }

                        //按照习题别名分类
                        that.paperExerciseList.forEach(function (item) {
                            let isSave = false;
                            that.paperExerciseListByExerciseTypeAlias.forEach(function (ExerciseTypeAliasItem) {
                                if (ExerciseTypeAliasItem.ExerciseTypeAliasId == item.ExerciseTypeAliasId) {
                                    isSave = true;
                                }
                            })
                            if (!isSave) {
                                that.paperExerciseListByExerciseTypeAlias.push({
                                    ExerciseTypeAliasId: item.ExerciseTypeAliasId,
                                    ExerciseTypeAliasName: item.ExerciseTypeAliasName,
                                    ExerciseList: that.paperExerciseList.filter(ex => {
                                        return ex.ExerciseTypeAliasId == item.ExerciseTypeAliasId;
                                    })
                                })
                            }
                        })
                        //给题类里的习题加序号
                        let i = 1;
                        that.paperExerciseListByExerciseTypeAlias.forEach(function (item) {
                            item.ExerciseList.forEach(function (ex) {
                                ex.Index = i;
                                i++;
                            })
                        })
                    } else {
                        that.paperExerciseList = [];
                        that.paperExerciseId = 0;
                        that.paperExerciseScore = 0;
                        that.paperExercise = "";
                    }
                    that.getIframeSrc(that.paperExerciseId);
                }
            )
        },


        //试卷手动录题
        getIframeSrc(exid) {
            let that = this;
            that.paperExerciseCreateIframeIsShow = false;
            let subname = encodeURIComponent(that.SubjectCourseName)
            setTimeout(function () {
                let href = tools._exerciseInput_arts + "index.html#type=chief&mode=paper&subid=" + that.SubjectCourseId + "&ischinese=" + (that.SubjectCourseName.indexOf('语文') > -1 ? 1 : 0) + "&subname=" + subname + "&expoolid=" + that.exercisePoolId;
                // let href = tools._exerciseInput_arts + "index.html#type=chief&mode=paper&subid=" + that.SubjectCourseId + "&ischinese=" + (that.SubjectCourseName.indexOf('语文') > -1 ? 1 : 0) + "&subname=" + subname + "&expoolid=" + that.exercisePoolId  + '&subjectCourse=' + that.subjectCourse;

                // 新建（没有id）：
                // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=paper&subid=863288426558&ischinese=1
                // 编辑（有id）：
                // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=paper&subid=863288426558&ischinese=1&exid=3118146275959
                if (exid && exid > 0) {
                    //编辑
                    href += "&exid=" + exid;
                    that.isCreateEx = false;
                    //传分数
                    if (that.paperExercise) {
                        let exeScore = {
                            Score: that.paperExercise.Score,
                            Questions: []
                        };
                        if (that.paperExercise.ExerciseDtos && that.paperExercise.ExerciseDtos.length > 0) {
                            exeScore.Questions = [];
                            that.paperExercise.ExerciseDtos.forEach(function (sub) {
                                exeScore.Questions.push(sub.Score)
                            })
                        }
                        href += '&exescore=' + JSON.stringify(exeScore);
                    }
                } else {
                    //创建
                    that.isCreateEx = true;
                    //默认使用最后的题型别名：
                    // https://artsentryexe.hexfuture.net/index.html#type=chief&mode=paper&subid=863288426558&ischinese=1&aliasid=863288428623
                    if (that.paperExerciseListByExerciseTypeAlias && that.paperExerciseListByExerciseTypeAlias.length > 0) {
                        let aliasid = that.paperExerciseListByExerciseTypeAlias[that.paperExerciseListByExerciseTypeAlias.length - 1].ExerciseTypeAliasId;
                        href += "&aliasid=" + aliasid;
                    }
                    //滚动到新加的小题
                    $(".excontent .exlist").animate({scrollTop: $(".addexone").offset().top - $(".excontent .exlist").offset().top + $(".excontent .exlist").scrollTop()}, 1000);
                }

                that.paperExerciseCreateIframeIsShow = true;
                that.paperExerciseCreateIframeSrc = href;
                that.paperExerciseCreateIframeLoad = true;
                that.$nextTick(function () {
                    let iframe = document.getElementById("paperExerciseCreateIframe");
                    iframe.onload = function () {
                        console.log("iframe.onload");
                        that.paperExerciseCreateIframeLoad = false;
                    };
                })
            }, 200)
        },
        addExercise() {
            let that = this;
            that.exerciseIframePostMessage(function () {
                that.paperExerciseId = 0;
                that.paperExercise = "";
                that.paperExerciseScore = 0;
                that.getIframeSrc(that.paperExerciseId);
            })
        },
        editExercise(one) {
            let that = this;
            that.exerciseIframePostMessage(function () {
                that.paperExerciseId = one.ExerciseId;
                that.paperExercise = one;
                that.getIframeSrc(that.paperExerciseId);
            })
        },
        //删除习题
        removePaperExercise(exerciseId) {
            let that = this;
            tools.api('ExercisePools.RemoveHtePaperToExerciseAsync', {
                htePaperId: that.paperId,
                exerciseId: exerciseId
            }, (data) => {
                that.$message({
                    message: '删除习题成功',
                    type: 'success'
                });
                that.paperExerciseId = undefined;
                that.paperExercise = "";
                that.getHtePoolHte();
            });
        },

        //========与录入习题交互start============
        exerciseIframePostMessage: function (callback) {
            let _this = this;
            _this.editExerciseIframeCallback = callback;

            var obj = {isCheckStriding: false, operation: "checkEx", timestamp: new Date().getTime()};
            document.getElementById('paperExerciseCreateIframe').contentWindow.postMessage(obj, "*");
        },
        exerciseIframeEventListener(e) {
            let _this = this;
            if (e.data.operation == "checkExBack") {
                console.log("监听事件触发:是否有未保存的习题" + e.data.count);
                let count = parseInt(e.data.count);
                if (count > 0) {
                    _this.isShowEditExerciseIframeConfim = true;
                } else {
                    if (typeof _this.editExerciseIframeCallback == "function") {
                        _this.editExerciseIframeCallback();
                        _this.editExerciseIframeCallback = "";
                    }
                }
            }
            if (e.data.method == "paperEntryEx") {
                console.log("监听事件触发:保存习题" + JSON.stringify(e.data.exMsg));
                _this.createOreditEx(e.data.exMsg);
            }
        },
        toSaveEx: function () {
            let _this = this;
            _this.isShowEditExerciseIframeConfim = false;
        },
        noSaveEx: function () {
            let _this = this;
            _this.isShowEditExerciseIframeConfim = false;
            if (typeof _this.editExerciseIframeCallback == "function") {
                _this.editExerciseIframeCallback();
            }
        },
        //保存编辑的习题
        createOreditEx: function (data) {
            let that = this;

            let ExerciseModel = {
                ExerciseId: data.id,
                Score: data.Score,
                ET: data.ET,
                ExerciseTypeAliasId: data.AliasID,
                ExerciseTypeAliasName: data.AliasName
            }
            //计算题小题
            if (data.childExMsg && data.childExMsg.length > 0) {
                ExerciseModel.ExerciseDtos = [];
                let QuestionsScore = 0;
                for (let item of data.childExMsg) {
                    ExerciseModel.ExerciseDtos.push({
                        ExerciseId: item.childId,
                        Score: item.Score,
                        ET: item.ET,
                        ExerciseTypeAliasId: item.AliasID,
                        ExerciseTypeAliasName: item.AliasName
                    })
                    QuestionsScore += parseFloat(item.Score);
                }
                ExerciseModel.Score = QuestionsScore;
            }

            if (that.isCreateEx) {
                //创建
                that.addExerciseForHtePaper(ExerciseModel)
            } else {
                //编辑
                that.updateExerciseForHtePaper(ExerciseModel)
            }

            console.log(ExerciseModel);
        },
        //添加试卷习题接口
        addExerciseForHtePaper(Exercise) {
            let that = this;
            that.paperExerciseList.push(Exercise);
            that.orderExerciseByExerciseTypeAlias();
            that.saveHtePaperExerciseCommon("add");
        },
        //编辑试卷习题接口, 检索重复习题会替换习题
        updateExerciseForHtePaper(Exercise) {
            let that = this;
            that.paperExerciseList.forEach(function (item) {
                if (item.ExerciseId == that.paperExerciseId) {
                    item.ExerciseId = Exercise.ExerciseId;
                    item.Score = Exercise.Score;
                    if (Exercise.ET == 'Compute' || Exercise.ET == 'LargeChoiceFillBlank') {
                        item.ExerciseDtos = Exercise.ExerciseDtos;
                    }
                }
            })
            that.orderExerciseByExerciseTypeAlias();
            that.saveHtePaperExerciseCommon("update");
        },
        //按照录入顺序的题型别名来排序
        orderExerciseByExerciseTypeAlias() {
            let that = this;
            let ExerciseTypeAlias = [];
            that.paperExerciseList.forEach(function (item) {
                let isSave = false;
                ExerciseTypeAlias.forEach(function (ExerciseTypeAliasItem) {
                    if (ExerciseTypeAliasItem.ExerciseTypeAliasId == item.ExerciseTypeAliasId) {
                        isSave = true;
                    }
                })
                if (!isSave) {
                    ExerciseTypeAlias.push({
                        ExerciseTypeAliasId: item.ExerciseTypeAliasId,
                        ExerciseTypeAliasName: item.ExerciseTypeAliasName,
                        ExerciseList: that.paperExerciseList.filter(ex => {
                            return ex.ExerciseTypeAliasId == item.ExerciseTypeAliasId;
                        })
                    })
                }
            })

            let ExerciseList = [];
            ExerciseTypeAlias.forEach(function (item) {
                ExerciseList = ExerciseList.concat(item.ExerciseList);
            })
            that.paperExerciseList = ExerciseList;
        },
        //保存习题公共方法 type=add\update\order
        saveHtePaperExerciseCommon: function (type) {
            let that = this;
            let Exercise = [];
            that.paperExerciseList.forEach(function (item) {
                let oneExercise = {ExerciseId: item.ExerciseId, Score: item.Score, ET: item.ET};
                if (item.ExerciseDtos && item.ExerciseDtos.length > 0) {
                    oneExercise.Questions = [];
                    item.ExerciseDtos.forEach(function (sub) {
                        oneExercise.Questions.push({ExerciseId: sub.ExerciseId, Score: sub.Score})
                    })
                }
                Exercise.push(oneExercise);
            })

            tools.api('ExercisePools.SaveHtePaperAndExerciseAsync', {
                HtePaperId: that.paperId,
                exercises: Exercise,
                IsUseRecord: false
            }, (data) => {
                let message = '';
                if (type == "add") {
                    message = '添加习题成功';
                }
                if (type == "update") {
                    message = '修改习题成功';
                }
                that.$message({
                    message: message,
                    type: 'success'
                });
                that.getHtePoolHte();
            });
        },
        //========与录入习题交互end============


        //=========拖拽操作start========
        onStart(evt) {
            this.drag = true;
        },
        onEnd(e) {
            this.drag = false;
            //拖拽完成后，date里的数据顺序会改变
            console.log(this.paperExerciseListByExerciseTypeAlias);
            this.orderHtePaperExerciseCommon();
        },
        //保存习题公共方法
        orderHtePaperExerciseCommon: function (type) {
            let that = this;
            let Exercise = [];

            that.paperExerciseListByExerciseTypeAlias.forEach(function (ExType) {
                ExType.ExerciseList.forEach(function (item) {
                    let oneExercise = {ExerciseId: item.ExerciseId, Score: item.Score, ET: item.ET};
                    if (item.ExerciseDtos && item.ExerciseDtos.length > 0) {
                        oneExercise.Questions = [];
                        item.ExerciseDtos.forEach(function (sub) {
                            oneExercise.Questions.push({ExerciseId: sub.ExerciseId, Score: sub.Score})
                        })
                    }
                    Exercise.push(oneExercise);
                })
            })

            tools.api('ExercisePools.SaveHtePaperAndExerciseAsync', {
                HtePaperId: that.paperId,
                exercises: Exercise,
                IsUseRecord: false
            }, (data) => {
                that.$message({
                    message: "习题调序成功",
                    type: 'success'
                });
                that.getHtePoolHte();
            });
        },
        //=========拖拽操作end========
    },
}
